import type React from 'react'

import iconSrc from '../../assets/logo/icon.svg'

export interface ArcsTokenIconProps {
  className?: string
}

export const ArcsTokenIcon: React.FC<ArcsTokenIconProps> = ({ className }) => {
  const hasSize =
    className?.includes('size-') || className?.includes('w-') || className?.includes('h-')
  return (
    <div
      className={`flex items-center justify-center ${hasSize ? '' : 'size-8'} ${className ?? ''}`}
      aria-hidden="true"
    >
      <img src={iconSrc} alt="" className="block size-full" />
    </div>
  )
}

export default ArcsTokenIcon
